"use client";

import React from "react";
import { HeartHandshake } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DonationMemorial() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="donationmemorial" className="bg-background py-24 px-6 min-h-auto flex items-center justify-center relative overflow-hidden">
      <div ref={ref} className={`w-full max-w-4xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <Card className="bg-card/20 backdrop-blur-sm border-border/20 shadow-md">
          <CardContent className="p-6 md:p-8 flex flex-col items-center text-center">
            <div className="mb-6 p-3 rounded-full bg-primary/5 border border-primary/10">
              <HeartHandshake className="w-8 h-8 text-primary opacity-80" strokeWidth={1.5} />
            </div>

            <h2 className="font-default text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-4 tracking-tight">
              Sostieni il Progetto SACROPAN
            </h2>

            <Separator className="w-16 bg-primary/30 mb-6 h-px" />

            <p className="font-default text-base md:text-lg text-secondary max-w-2xl mx-auto mb-8 leading-relaxed">
              Il tuo contributo ci permette di continuare a portare la musica
              dell'handpan nei luoghi sacri della Grande Guerra. Aiutaci a
              onorare la memoria degli Alpini e di tutti i caduti, documentando
              queste escursioni e mantenendo vive le loro storie per le
              generazioni future.
            </p>

            <Link to="https://www.paypal.com/donate/?business=YOUR_PAYPAL_ID">
              <Button variant="outline" size="sm" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground font-default tracking-wide uppercase transition-all duration-300">
                Sostieni su PayPal
              </Button>
            </Link>
          </CardContent>
        </Card>
      </div>
    </section>;
}